export interface SelectionToggleInput {
  selectedIds: string[];
  anchorId: string | null;
  itemId: string;
  orderedIds: string[];
  additive: boolean;
  range: boolean;
}

export interface SelectionToggleResult {
  selectedIds: string[];
  anchorId: string | null;
}

function uniqueIds(ids: string[]): string[] {
  return Array.from(new Set(ids));
}

function getRangeIds(orderedIds: string[], anchorId: string, itemId: string): string[] {
  const anchorIndex = orderedIds.indexOf(anchorId);
  const itemIndex = orderedIds.indexOf(itemId);

  if (anchorIndex === -1 || itemIndex === -1) {
    return [itemId];
  }

  const start = Math.min(anchorIndex, itemIndex);
  const end = Math.max(anchorIndex, itemIndex);
  return orderedIds.slice(start, end + 1);
}

export function toggleSelectionIds(input: SelectionToggleInput): SelectionToggleResult {
  const { additive, anchorId, itemId, orderedIds, range, selectedIds } = input;

  if (range && anchorId) {
    const rangeIds = getRangeIds(orderedIds, anchorId, itemId);
    return {
      selectedIds: additive ? uniqueIds([...selectedIds, ...rangeIds]) : rangeIds,
      anchorId
    };
  }

  if (additive) {
    const nextSelectedIds = selectedIds.includes(itemId)
      ? selectedIds.filter((selectedId) => selectedId !== itemId)
      : [...selectedIds, itemId];

    return {
      selectedIds: nextSelectedIds,
      anchorId: itemId
    };
  }

  const isSingleSelected = selectedIds.length === 1 && selectedIds[0] === itemId;

  return {
    selectedIds: isSingleSelected ? [] : [itemId],
    anchorId: isSingleSelected ? null : itemId
  };
}

export function removeSelectedId(selectedIds: string[], itemId: string): string[] {
  return selectedIds.filter((selectedId) => selectedId !== itemId);
}

export function countHiddenSelectedIds(selectedIds: string[], visibleIds: string[]): number {
  const visibleIdSet = new Set(visibleIds);
  return selectedIds.filter((selectedId) => !visibleIdSet.has(selectedId)).length;
}
